import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Initials avatar (mockup `.prof-av` / `.prof-av-lg`). Pass a name (→ initials) or explicit text. */
@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  private readonly _name = signal('');
  private readonly _text = signal('');

  @Input() set name(v: string) { this._name.set(v ?? ''); }
  @Input() set text(v: string) { this._text.set(v ?? ''); }
  @Input() size: 'sm' | 'lg' = 'sm';
  @Input() imageUrl?: string | null;

  readonly initials = computed(() => {
    if (this._text()) return this._text();
    const parts = this._name().trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    const a = parts[0][0] ?? '';
    const b = parts.length > 1 ? (parts[1][0] ?? '') : '';
    return (a + b).toUpperCase();
  });
}
